














































































































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class PricingInfo extends Vue
{
    selectedSubset : number = 0;
    readonly noSelectedSubsetText : string = 'All Options';
    subsets : string[] = [
        'School/Department/Company',
        'Class or Team',
        'Self',
        this.noSelectedSubsetText,
    ];

    planInfo : any[] = [
        {
            subset: 3,
            title: 'Free',
            pricePerMonth: 0,
            description: 'Use ClioVis for free, no credit card required!',
            featureList: [
                '1 Project with unlimited Timelines',
                `You can only join ${this.generateHyperlink('Upgraded Projects', 'https://cliovis.com/pricing/#faq')}`,
                '10 image or audio file uploads',
                'Up to 20 Events in Timelines',
                '',
            ],
            actionText: 'SIGN UP',
            actionURL: 'https://webapp.cliovis.com/register',
        },
        {
            subset: 3,
            title: 'Premium',
            pricePerMonth: 7.99,
            description: 'All features unlocked for a single user!',
            featureList: [
                'Unlimited Projects with unlimited Timelines',
                'You can join any Project',
                '100 image or audio file uploads',
                'Unlimited Events in Timelines',
                '',
            ],
            actionText: 'FREE TRIAL',
            actionURL: 'https://webapp.cliovis.com/register',
        },
        {
            subset: 2,
            title: 'Upgraded Project',
            priceText: 'Varied\nstarting at $24.99 / month',
            description: 'A group of Free users can benefit from Premium features in a single Project!',
            featureList: [
                '1 Project with unlimited Timelines',
                '20 - 250 Free users can join, depending on the selected plan',
                '10 image or audio file uploads per person for Free users',
                'Unlimited Events in Timelines',
                '',
            ],
            actionText: 'FIND OUT MORE',
            actionURL: 'https://cliovis.com/pricing/#how-to-vid',
        },
        {
            subset: 1,
            title: 'Enterprise',
            priceText: 'Contact us for pricing',
            description: 'LMS integration + Premium features for a large number of users!',
            featureList: [
                'Unlimited Projects with unlimited Timelines',
                'Members can join any Project',
                '100 image or audio file uploads per person',
                'Unlimited Events in Timelines',
                'Integration with your LMS (e.g. Canvas, Blackboard)',
            ],
            actionText: 'CONTACT US',
            actionURL: 'https://cliovis.com/contact-us/',
        },
    ];

    get planInfoSubset()
    {
        return (
            (this.selectedSubset > 0)
                ? this.planInfo.filter(plan => plan.subset === this.selectedSubset)
                : this.planInfo
        );
    }

    selectSubset(subset : string, i : number)
    {
        if (subset === this.noSelectedSubsetText)
        {
            this.selectedSubset = 0;
        }
        else
        {
            this.selectedSubset = 1 + i;
        }
    }

    isSubsetSelected(subset : string, i : number) : boolean
    {
        if (subset === this.noSelectedSubsetText)
        {
            return this.selectedSubset === 0;
        }
        return this.selectedSubset === (1 + i);
    }

    /** automatically adds target="_top" so it functions from inside an iframe */
    generateHyperlink(text: string, url: string) : string
    {
        return `<a target="_top" href="${url}">${text}</a>`;
    }
}
